import React, {useContext, useEffect, useRef, useState} from 'react';
import './ModalAgent.scss';
import {Input, Modal, Select, Switch, Tooltip} from "antd";
import {ArrowLeftIcon, CloseStrokeIcon, DeleteIcon, EditIcon, NotificationIcon} from "../../../../image";
import {Button} from "../../../../modules/Button";
import {useTranslation} from "react-i18next";
import {Text} from "../../../../modules";
import TextArea from "antd/es/input/TextArea";
import {
    findTimeValue, Frequency, getNextTimeDate,
    getNextWeekdayDate,
    getOptionsFrequencySelect,
    getOptionsTimeSelect,
    getOptionsTimezonesSelect,
    getOptionsWeekDaysSelect, getTimezone, getWeekdayFromDate, TRIGGER_TYPE
} from "../../helpers";
import {ToastContext} from "../../../../modules/Toast/ToastContext";
import {useDispatch, useSelector} from "react-redux";
import {
    CreateAgentService,
    DeleteAgentService,
    GetAgentsService,
    GetTemplatesAgentsService,
    UpdateAgentService
} from "../../../../redux/actions";
import dayjs from "dayjs";
import {formatDatetimeWithTimezone} from "../../../../utils/helperFunctions";
import {Loader} from "../../../../shared/features/Loader";
import ModalLimitConnection from "../ModalLimitConnection/ModalLimitConnection";

const ModalAgent = ({show, onClose, templateId, agentId}) => {
    const {t, i18n} = useTranslation();
    const [isEdit, setIsEdit] = useState(false);
    const [isVisibleTooltip, setIsVisibleTooltip] = useState(false);
    const buttonRef = useRef();
    const dispatch = useDispatch();
    const {setToastInfo} = useContext(ToastContext);
    const template = useSelector(state => state.agents.templatesList || []).find((agent) => agent?.id === templateId);
    const agent = useSelector(state => state.agents.agentsInfo?.agents || []).find((agent) => agent?.id === agentId);
    const language = useSelector(state => state.agents.language);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [isVisibleLimitModal, setIsVisibleLimitModal] = useState(false);
    const agentsInfo = useSelector(state => state.agents.agentsInfo);
    const nameRef = useRef(null);
    const descriptionsRef = useRef(null);
    const isEditRef = useRef(false);
    const [loadingSwitch, setLoadingSwitch] = useState(false);

    useEffect(() => {
        isEditRef.current = isEdit;
    }, [isEdit])

    const [data, setData] = useState({
        description: '',
        instruction: '',
        name: '',
        target: '',
        trigger_type: 'TriggerEnum.on_video_process',
        schedule_trigger_model: {
            frequency: "FrequencyEnum.daily",
            datetime: dayjs(),
            timezone_offset: 180
        },
        language: 'TemplateLanguage.english',
        is_active: true
    });
    const isTriggerProcessed = data?.trigger_type === TRIGGER_TYPE.ON_VIDEO_PROCESS;

    const initData = () => {
        if (templateId && template) {
            if (template?.trigger_type === TRIGGER_TYPE.ON_VIDEO_PROCESS) {
                setData({
                    name: template?.name || '',
                    description: template?.description || '',
                    instruction: template?.instruction || '',
                    target: '',
                    trigger_type: template?.trigger_type,
                    is_active: true
                })
            } else {
                setData({
                    name: template?.name || '',
                    description: template?.description || '',
                    instruction: template?.instruction || '',
                    target: template?.target || '',
                    trigger_type: template?.trigger_type,
                    is_active: true,
                    schedule_trigger_model: {
                        frequency: "FrequencyEnum.daily",
                        datetime: dayjs(),
                        timezone_offset: dayjs().utcOffset()
                    },
                })
            }

        }
        if (agentId && agent) {
            if (template?.trigger_type === TRIGGER_TYPE.ON_VIDEO_PROCESS) {
                setData({
                    name: agent?.name || '',
                    description: agent?.description || '',
                    instruction: agent?.instruction || '',
                    target: agent?.target,
                    trigger_type: agent?.trigger_type,
                    is_active: Boolean(agent?.is_active)
                })
            } else {
                setData({
                    name: agent?.name || '',
                    description: agent?.description || '',
                    instruction: agent?.instruction || '',
                    target: agent?.target,
                    trigger_type: agent?.trigger_type,
                    schedule_trigger_model: {
                        frequency: agent?.schedule_trigger_model?.frequency,
                        datetime: agent?.schedule_trigger_model?.datetime,
                        timezone_offset: agent?.schedule_trigger_model?.timezone_offset
                    },
                    is_active: Boolean(agent?.is_active)
                })
            }
        }
    }

    useEffect(() => {
        initData()
    }, [show, agentId, templateId])

    useEffect(() => {
        if (buttonRef?.current && show && templateId) {
            setTimeout(() => {
                setIsVisibleTooltip(true);
            }, 1500)
        }
    }, [buttonRef, show]);

    const closeModal = () => {
        setIsVisibleTooltip(false);
        setIsEdit(false);

        setTimeout(() => {
            onClose();
            setData({
                description: '',
                instruction: '',
                target: '',
                trigger_type: 'TriggerEnum.on_video_process',
                schedule_trigger_model: {
                    frequency: "daily",
                    datetime: dayjs('2024-05-10 20:26'),
                    timezone_offset: 0
                }
            })
        }, 100)
    }

    const onChangeData = (key, value) => {
        setData({
            ...data,
            [key]: value
        })
    }

    const onChangeSelectData = (key, value) => {
        if (key === 'week') {
            setData({
                ...data,
                'schedule_trigger_model': {
                    ...data?.schedule_trigger_model,
                    datetime: getNextWeekdayDate(value)
                }
            })
        } else if (key === 'minutes') {
            setData({
                ...data,
                'schedule_trigger_model': {
                    ...data?.schedule_trigger_model,
                    datetime: getNextTimeDate(value)
                }
            })
        } else {
            setData({
                ...data,
                'schedule_trigger_model': {
                    ...data?.schedule_trigger_model,
                    [key]: value
                }
            })
        }
    }

    const save = () => {
        createAgent();

    }

    const switchAgent = async (agent, value) => {
        try {
            if (agentId) {
                setLoadingSwitch(true)
                await UpdateAgentService(agent?.id, {is_active: !agent?.is_active});
                dispatch(GetAgentsService());
                setTimeout(()=>setLoadingSwitch(false),500)
            } else {
                onChangeData("is_active", value)
            }
        } catch (e) {
            console.error(e)
        }
    }

    const createAgent = async () => {
        try {
            setLoadingSave(true)
            if (templateId) {
                if (agentsInfo?.agents_total >= agentsInfo?.max_agents_count) {
                    setIsVisibleLimitModal(true)
                } else {
                    if (isTriggerProcessed) {
                        await CreateAgentService({
                            name: data?.name,
                            description: data?.description,
                            instruction: data?.instruction,
                            user_agent_template_id: templateId,
                            is_active: data?.is_active,
                        });
                    } else {
                        await CreateAgentService({
                            name: data?.name,
                            description: data?.description,
                            instruction: data?.instruction,
                            language: "english",
                            user_agent_template_id: templateId,
                            target: data?.target,
                            is_active: data?.is_active,
                            schedule_trigger_model: {
                                frequency: Frequency[data?.schedule_trigger_model?.frequency],
                                datetime_with_tz: formatDatetimeWithTimezone(data?.schedule_trigger_model?.datetime, data?.schedule_trigger_model?.timezone_offset)
                            }
                        });
                    }

                    setToastInfo({
                        isShow: true,
                        type: 'success',
                        text: t("success_created_agent")
                    });
                    dispatch(GetTemplatesAgentsService(language));
                    dispatch(GetAgentsService());
                }
            } else {
                if (isTriggerProcessed) {
                    await UpdateAgentService(agentId, {
                        name: data?.name,
                        description: data?.description,
                        instruction: data?.instruction,
                        user_agent_template_id: agent?.user_agent_template_id,
                        is_active: data?.is_active,
                    })
                } else {
                    await UpdateAgentService(agentId, {
                        name: data?.name,
                        description: data?.description,
                        instruction: data?.instruction,
                        user_agent_template_id: agent?.user_agent_template_id,
                        is_active: data?.is_active,
                        schedule_trigger_model: {
                            frequency: Frequency[data.schedule_trigger_model.frequency],
                            datetime_with_tz: formatDatetimeWithTimezone(data?.schedule_trigger_model?.datetime, data?.schedule_trigger_model?.timezone_offset)
                        },
                        target: data?.target
                    })
                }
                setToastInfo({
                    isShow: true,
                    type: 'success',
                    text: t("success_update_agent")
                });
                dispatch(GetAgentsService());
            }
            setLoadingSave(false);
            closeModal();
        } catch (error) {
            setLoadingSave(false);
            console.error(error)
        }
    }

    const deleteAgent = async () => {
        try {
            setLoading(true)
            await DeleteAgentService(agentId);
            setToastInfo({
                isShow: true,
                type: 'success',
                text: t("success_deleted_agent")
            });
            dispatch(GetAgentsService());
            setLoading(false);
            closeModal();
        } catch (e) {
            setLoading(false);
            setToastInfo({
                isShow: true,
                type: 'error',
                text: t("error_delete_agent")
            });
            console.error(e)
        }
    }

    useEffect(() => {
        const handleClick = async (event) => {
            if (isEditRef?.current) {
                if (
                    (nameRef?.current?.input && nameRef.current.input.contains(event.target)) ||
                    (descriptionsRef?.current?.resizableTextArea.textArea && descriptionsRef?.current?.resizableTextArea.textArea.contains(event.target))
                ) {
                    console.log('Клик ВНУТРИ input');
                } else {
                    if (isEditRef?.current) {
                        setIsEdit(false)
                    }
                }
            }

        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <>
            {isVisibleLimitModal ?
                <ModalLimitConnection open={isVisibleLimitModal} onClose={(e) => {
                    setIsVisibleLimitModal(false);
                    // onOpen();
                    e.stopPropagation()
                }}/>
                :
                <Modal
                    open={show}
                    onCancel={closeModal}
                    centered
                    classNames={{
                        mask: 'modal-agent__mask',
                        content: 'modal-agent__content',
                        wrapper: 'modal-agent__wrapper',
                    }}
                    className={'modal-agent'}
                    onWheel={(e) => e.stopPropagation()}
                >
                    <div className="modal-agent__header">
                        <div className="modal-agent__header-wrap">
                            <Text

                                style={{width: isEdit ? '100%' : 'auto'}}
                                size="f20" font="medium" className="modal-agent__header--title">
                                {isEdit ?
                                    <Input ref={nameRef} value={data?.name}
                                           onChange={(e) => onChangeData('name', e?.target?.value)}/>
                                    :
                                    <Text size="f20" font="medium">
                                        {data?.name} {templateId ? `(${t('copy')})` : ''}
                                    </Text>
                                }
                            </Text>
                            {isEdit ? null : <EditIcon onClick={(e) => {
                                e.stopPropagation();
                                setIsEdit(true);
                            }}/>}
                            {isEdit ?
                                null
                                :
                                <Tooltip
                                    trigger='hover'
                                    placement="top"
                                    title={t('agent_switch_tooltip')}
                                >
                                    <Switch
                                        loading={loadingSwitch}
                                        checked={agentId ? agent?.is_active : data?.is_active}
                                        className="modal-agent__header--switch"
                                        onChange={(value) => switchAgent(agent, value)}
                                    />
                                </Tooltip>
                            }
                            <CloseStrokeIcon onClick={closeModal} className="modal-agent__header--close"/>
                        </div>
                        {isEdit ?
                            <Input.TextArea
                                ref={descriptionsRef}
                                value={data?.description}
                                onChange={(e) => onChangeData('description', e?.target?.value)}
                                rows={2}
                                style={{resize: 'none'}}
                                maxLength={155}
                            />
                            :
                            <Text size="f14" font="book" color="#9898A6">
                                {data?.description}
                            </Text>
                        }
                    </div>
                    <div className="modal-agent__body">


                        <div className="modal-agent__instruction">
                            <Text size="f16" font="bold">
                                {t('instruction')}
                            </Text>
                            <Text size="f14" font="book" color="#9898A6">
                                {t('instruction_text')}
                            </Text>
                            <TextArea
                                rows={3} style={{resize: 'none'}}
                                value={data?.instruction}
                                onChange={(e) => onChangeData('instruction', e?.target?.value)}
                                status={data?.instruction ? "" : "error"}
                            />
                            {!data?.instruction ? <Text size="f14" color="red"
                                                        style={{marginTop: -8}}>{t('instructions_error_text')}</Text> : null}
                        </div>
                        <div className="modal-agent__triggers">
                            <Text size="f16" font="bold">
                                {t('trigger')}
                            </Text>

                            <div className="modal-agent__triggers--filter">
                                <NotificationIcon className="modal-agent__triggers--filter-icon"/>
                                {isTriggerProcessed ?
                                    <Text font="book" size="f14">{t('after_each')}</Text>
                                    :
                                    <Text font="book" size="f14">{t('frequency_text')}</Text>
                                }
                                {/*<Tooltip*/}
                                {/*    trigger='hover'*/}
                                {/*    placement="left"*/}
                                {/*    title={*/}
                                {/*        <>*/}
                                {/*            <p>Mute/unmute chat</p>*/}
                                {/*            <p>notifications from this agent</p>*/}
                                {/*        </>*/}
                                {/*    }*/}
                                {/*>*/}
                                {/*    <Switch*/}
                                {/*        // checked={agentId ? agent?.is_active : data?.is_active}*/}
                                {/*        className="modal-agent__switch-notification"*/}
                                {/*        // onChange={(value) => switchAgent(agent, value)}*/}
                                {/*    />*/}
                                {/*</Tooltip>*/}
                            </div>
                            {isTriggerProcessed ? null :
                                <div className="modal-agent__triggers--selects">
                                    <Select
                                        suffixIcon={<ArrowLeftIcon/>}
                                        options={getOptionsFrequencySelect(i18n.language)}
                                        value={data?.schedule_trigger_model?.frequency}
                                        onChange={(value) => onChangeSelectData('frequency', value)}
                                    />
                                    {data.schedule_trigger_model.frequency === "FrequencyEnum.weekly" ?
                                        <Select
                                            suffixIcon={<ArrowLeftIcon/>}
                                            options={getOptionsWeekDaysSelect(i18n.language)}
                                            value={getWeekdayFromDate(data?.schedule_trigger_model?.datetime, i18n.language)}
                                            onChange={(value) => onChangeSelectData('week', value)}
                                        />
                                        : null
                                    }
                                    <Select
                                        suffixIcon={<ArrowLeftIcon/>}
                                        options={getOptionsTimeSelect(i18n.language)}
                                        value={findTimeValue(data?.schedule_trigger_model?.datetime)}
                                        onChange={(value) => onChangeSelectData('minutes', value)}

                                    />
                                    <Select
                                        value="UTC+00:00"
                                        suffixIcon={<ArrowLeftIcon/>}
                                        options={getOptionsTimezonesSelect()}
                                        value={getTimezone(data?.schedule_trigger_model?.timezone_offset)}
                                        onChange={(value) => onChangeSelectData('timezone_offset', value)}
                                    />
                                </div>
                            }
                        </div>
                        {isTriggerProcessed ? null :
                            <div className="modal-agent__instruction">
                                <Text size="f16" font="medium">
                                    {t('target')}
                                </Text>
                                <Text size="f14" font="book" color="#9898A6">
                                    {t('target_text')}
                                </Text>
                                <TextArea
                                    value={data?.target || ''}
                                    onChange={(e) => onChangeData('target', e?.target?.value)}
                                    rows={4} style={{resize: 'none'}}
                                    placeholder={t('example_target')}
                                />
                            </div>
                        }
                        {agentId ?
                            <div className="modal-agent__delete">
                                <Text size="f16" font="bold">
                                    {t('delete_agent_title')}
                                </Text>
                                <div className="modal-agent__delete-block">
                                    <Text size="f14" font="book" color="#9898A6">
                                        {t('delete_agent_info')}
                                    </Text>
                                    <Button
                                        text={t('button_delete')}
                                        onClick={deleteAgent}
                                        size={'xs'}
                                        color="red"
                                        variant="ghost"
                                    />
                                </div>
                            </div>
                            : null}
                    </div>

                    <div className="modal-agent__footer" ref={buttonRef}>
                        <Button
                            text={t('button_cancel')}
                            variant={'secondary'}
                            size={'m'}
                            onClick={closeModal}
                            disabled={loading}
                            leftIcon={loading ? <Loader size={20} color="red"/> : null}
                        />
                        <Tooltip
                            placement="top"
                            open={isVisibleTooltip}
                            title={
                                <div className="modal-agent__tooltip">
                                    <p>{t('agent_tooltip_text')}</p>
                                    <div className="modal-agent__tooltip-wrap">
                                        <CloseStrokeIcon onClick={() => setIsVisibleTooltip(false)}/>
                                    </div>
                                </div>}
                        >
                            <Button
                                text={agentId ? t('button_save') : t('profile_create_tag')}
                                onClick={()=>{
                                    if(!loadingSave){
                                        save()
                                    }
                                }}
                                size={'m'}
                                leftIcon={loadingSave ? <Loader size={20} color="white"/> : null}
                                disabled={loadingSave}
                            />
                        </Tooltip>
                    </div>
                </Modal>
            }
        </>
    );
};

export default ModalAgent;